<template>
  <div class="page has-sidebar has-sidebar-fluid has-sidebar-expand-xl">
    <!-- .page-inner -->
    <div class="page-inner page-inner-fill position-relative">
      <header class="page-navs shadow-sm">
        <!-- .input-group -->
        <div class="input-group has-clearable">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">
              <em class="fa fa-times-circle"></em>
            </span>
          </button>
          <label class="input-group-prepend" for="searchClients">
            <span class="input-group-text">
              <span class="oi oi-magnifying-glass"></span>
            </span>
          </label>
          <input type="text" class="form-control" id="searchClients" data-filter=".board .list-group-item" placeholder="Find policy">
        </div><!-- /.input-group -->
      </header>

      <div class="board p-0 perfect-scrollbar" id="container-policy">
        <!-- .list-group -->
        <div class="list-group list-group-flush list-group-divider border-top" data-toggle="radiolist">
          <div class="list-group-item"  :class="{ 'active' : i == 0}" data-toggle="sidebar" data-sidebar="show"  v-for="(item, i) in list_policy">
            <a @click="policy_id=item.id;getItems()" class="stretched-link"></a>
            <div class="list-group-item-figure">
              <div class="tile tile-circle" :class="item.bg_color">{{item.title.substring(0, 1)}}</div>
            </div>
            <div class="list-group-item-body">
              <h4 class="list-group-item-title">{{item.title}}</h4>
              <p class="list-group-item-text">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-sidebar bg-light">
      <!-- .sidebar-header -->
      <header class="sidebar-header d-xl-none">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="#" onclick="Looper.toggleSidebar()"><em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Back</a>
            </li>
          </ol>
        </nav>
      </header>
      <div class="sidebar-section sidebar-section-fill">
        <h1 class="page-title">
          <em class="fa fa-book text-muted mr-2"></em> POLICY & REGULATIONS
        </h1>
        <div class="row">
          <div class="col-lg-12">
            <div class="card card-fluid">
              <div class="list-group list-group-flush list-group-divider">
                <template  v-if="list.length > 0">
                <div class="list-group-item" v-for="(item,i) in list">
                  <div class="list-group-item-figure">
                    <a :href="urlDownload+item.filepath+item.filename" target="_blank" class="tile tile-circle" :class="item.bg_color">
                      <span class="fa" :class="item.class"></span>
                    </a>
                  </div>
                  <div class="list-group-item-body">
                    <h4 class="list-group-item-title">
                      <a :href="urlDownload+item.filepath+item.filename" target="_blank">{{item.name}}</a>
                    </h4>
                    <p class="list-group-item-text"> {{item.last_modified}} </p>
                  </div>
                  <div class="list-group-item-figure">
                    <button class="btn btn-sm btn-icon btn-light" @click="downloadFile(item, $event)"><em class="oi oi-data-transfer-download"></em></button>
                  </div>
                </div>
                </template>
                <template v-else>
                  <div class="list-group-item">
                    <div class="list-group-item-body">
                      <h4 class="list-group-item-title">
                        <a href="#">Data not found</a>
                      </h4>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="row align-items-center">
              <pagination-info :per-page="perPage" :rows="total" :current-page="currentPage"></pagination-info>
              <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                <div class="dataTables_paginate paging_simple_numbers">
                  <b-pagination v-model="currentPage" :per-page="perPage" v-on:click="getItems"   :total-rows="total" ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="assets/vendor/perfect-scrollbar/perfect-scrollbar.min.js"></script>
<script src="assets/javascript/theme.min.js"></script>
<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import  {BPagination} from 'bootstrap-vue'
import PaginationInfo from "../../PaginationInfo";

export default {
  name: "PolicyRegulation",
  components:{
    PaginationInfo,
    BPagination
  },
  data(){
    return {
      loading:false,
      list_policy:[],
      bg_color:['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray'],
      list:[],
      currentPagePolicy:1,
      perPagePolicy:15,
      currentPage:1,
      perPage:10,
      policy_id:"",
      urlDownload:process.env.VUE_APP_URL_BACKEND,
      total:0
    }
  },
  watch:{
    currentPage:function (){
      this.getItems()
    }
  },
  methods:{
    getListPolicy(){
      this.loading = true
      let payload = {
        lang:'en',
        page:this.currentPagePolicy,
        limit:this.perPagePolicy
      }
      AxiosCall.Get(payload, urlApi.intranet.list_policy_regulation).then(res=>{
        if(res.success){
          for (let i in res.atributes){
            const random = Math.floor(Math.random() * this.bg_color.length);
            res.atributes[i].bg_color = this.bg_color[random]
            if(i == 0 && this.policy_id == "") {
              this.policy_id = res.atributes[i].id
              this.getItems()
            }
           this.list_policy.push(res.atributes[i])
          }
          this.currentPagePolicy++;
        }else{
          this.$parent.errorMessage(res.message)
        }
        this.loading = false
        if(res.total == this.list_policy.length){
          this.loading = true
        }

      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getItems(){
      this.list = []
      let payload = {
        page:this.currentPage,
        limit:this.perPage
      }
      if (this.policy_id !== "") payload.policy_id=this.policy_id
      AxiosCall.Get(payload, urlApi.intranet.list_policy_regulation_file).then(res=>{
        if(res.success){
          for(let i in res.atributes){
            let data = res.atributes[i]
            let class_css
            switch (data.filetype){
              case "pdf":
                class_css = 'fa-file-pdf'
                break
              case "xls":
                class_css = 'fa-file-excel'
                break
              case "xlsx":
                class_css = 'fa-file-excel'
                break
              case "docx":
                class_css = 'fa-file-word'
                break
              default:
                class_css = 'fa-file'
            }

            data.class = class_css
            const random = this.random()
            if(i != 0 ){
              data.bg_color = this.bg_color[random] === res.atributes[i-1].bg_color ? this.bg_color[this.random()] : this.bg_color[random]
            }else {
              data.bg_color = this.bg_color[random]
            }

            this.list.push(data)
          }
          this.total = res.total
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    downloadFile(item, evt){
      evt.preventDefault()
      AxiosCall.DownloadFile(this.urlDownload+item.filepath+item.filename, item.name)
    },
    random(){
      let key = this.getRandomInt(0, 10);
      return key
    },
    getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
  },
  mounted() {
    let ini = this
    if (window.PerfectScrollbar && $('.perfect-scrollbar').length > 0) {
      let ps
      $('.perfect-scrollbar:not(".aside-menu")').each(function () {
        if(this.id === 'container-policy'){
          ps = new PerfectScrollbar(this, {
            suppressScrollX: true,
            wheelPropagation: false,
          })
          document.querySelector('#container-policy').addEventListener('ps-y-reach-end', () => {
            setTimeout(()=>{
              if(!ini.loading) ini.getListPolicy()
            }, 20)

            setTimeout(()=>{
              ps.update()
            }, 30)

          });
        }
      })
    }
    this.getListPolicy()
  }
}
</script>

<style scoped>
.shadow-sm{
  box-shadow:0rem 0rem !important;
}
</style>